// removed by extract-text-webpack-plugin
module.exports = {"matchup":"Matchup__matchup--2fZ0b"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/TableControls/Matchup/Matchup.css
// module id = izs7
// module chunks = 47